import BaseObject from '../../../base/base_object';
import Event from '../../../utils/event';
import {SYSTEM_EVENTS} from '../../../events/events';
import _ from '../../../utils/underscore';
import ServiceFactory from '../../../services/service_factory';
import {PRODUCT_PACKAGE_MAP} from './external_links_base_handler_consts';
import {isCashoutSessionType, isDepositSessionType} from "../../../../../common/utils/cashier-util";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";
import {GNWP_SOURCES} from "../external_links_consts";
/**
 *
 */
class ExternalLinksBaseHandler extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksBaseHandler';

	_acceptedSourcesMap = [];

    /**
     *
     * @param params
     */
    init(params) {
        params = params || {};
        super.init(params);
        this.componentControllerRef = params.component;
        this._serviceFactory = params.serviceFactory || ServiceFactory.create();
    }


	/**
     * Returns a list of accepted sourcepackageIDs for a handler
     * Override this in the handlers which require it
	 * @returns {Array}
	 */
	getAcceptedSourcesMap() {
		return [
			PRODUCT_PACKAGE_MAP.MY_ACCOUNT_PP_ID,
			PRODUCT_PACKAGE_MAP.MEMBERSHIP_PP_ID,
			PRODUCT_PACKAGE_MAP.CHANGE_PASSWORD_PP_ID,
			PRODUCT_PACKAGE_MAP.PENDING_APPLICATION_PP_ID,
			PRODUCT_PACKAGE_MAP.REDEEM_COMP_POINTS_PP_ID
        ];
	}


	/**
     * Checks if the data received on post message is valid
	 * @param postMessageData data received from POST
	 * @returns {boolean}
	 */
	checkPostMessageData(postMessageData) {
        if (!postMessageData || !postMessageData.ActionId) {
			this.logger.debug('ActionID is null or undefined');
            return false;
        }
        return true;
    }


	/**
     *
	 * @param source
	 * @returns {boolean}
	 */
	isSourceValid(source) {
        let acceptedSources = this.getAcceptedSourcesMap();
        let productPackage;

        // TODO: remove SourceProductPackage test when correct source format is received

        if (!_.propertyChainExists(source, 'originInformation.originProductPackageID')) {
            if (!_.isUndefined(source.SourceProductPackage)) {
                productPackage = source.SourceProductPackage;
            } else {
				this.logger.debug('originProductPackageID not found');
				return false;
			}
		} else {
            productPackage = source.originInformation.originProductPackageID;
        }

        // if (acceptedSources.indexOf(source.originInformation.originProductPackageID) < 0) {
        if (acceptedSources.indexOf(productPackage) < 0) {
            // this.logger.error('Wrong originProductPackageID ' + source.originInformation.originProductPackageID);
            this.logger.debug('Wrong originProductPackageID ' + productPackage);
            return false;
        }
		this.logger.debug('========== EXTERNAL LINKS HANDLER START ==========');
		this.logger.debug('Correct originProductPackageID ' + productPackage);
		this.logger.debug(source);
		this.logger.debug('=========== EXTERNAL LINKS HANDLER END ===========');
        return true;
    }


    /**
     * decide if iframe needs to be displayed
     *
     */
    display() {
        this.componentControllerRef.display();
    }

    /**
     * Handle link close
     */
    onComponentClose() {}

    /**
     * Handle overlay close button click event
     */
    onBtnCloseClicked() {
        this.sendAnalytics({label: 'CloseBtnClicked'});
    }

    /**
     * Close this component overlay
     */
    close(postAction) {
        this.componentControllerRef.closeLink(postAction);
    }


    /**
     *
     * @param postMessageData
     */
    handlePostMessage(postMessageData) {
        if (this.checkPostMessageData(postMessageData)) {
			if (this.isSourceValid(postMessageData)) {
				this.logger.debug('All tests passed, executing postMessageAction');
				this.sendAnalytics({
                    label: 'PostMessage: ' + JSON.stringify(postMessageData)
				});
				this.executePostMessageAction(postMessageData);
			} else {
				this.executePostMessageActionFallback(postMessageData);
			}
		}
    }


	/**
     * What should happen when the handler receives a postMessageData that passed all the tests
     * Override this and add your custom functionality
	 * @param postMessageData
	 */
	executePostMessageAction(postMessageData) {

    }


	/**
	 * Fallback for when the handler received an invalid postMessageData
	 * Useful in cases where originProductPackageID or SourceProductPackage do not exist
	 * @param postMessageData
	 */
	executePostMessageActionFallback(postMessageData) {

	}


    /**
     * Fires SYSTEM_EVENTS.EXTERNAL_LINK_OPEN event
     * @param params
     */
    openExternalLink(params) {
        if (!params) {
            return;
        }
        Event.fire(SYSTEM_EVENTS.EXTERNAL_LINK_OPEN, params);
    }

    /**
     *
     * @param analyticObject
     */
    sendAnalytics(analyticObject) {
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, Object.assign({
            category: '[Technical-event]',
            action: 'ExternalLink ' + this.getHandlerName(),
        }, analyticObject));
    }


    getHandlerName() {
        return 'BaseHandler';
    }

    /**
     * Get source link to be opened in external link . (override this method)
     */
    getSourceLink() {}

    /**
     * Handle post message with ActionId = 6 - CASHIER
     * @param postMessageData
     * @private
     */
    openCashier(postMessageData, channel) {
        if (!postMessageData.TabId) {
            this.logger.warn('TabId is undefined or empty. Unable to open cashier with specified SessionType. Opening default cashier');
        }
        let options = {};
        if (postMessageData.TabId) {
            options.sessionType = postMessageData.TabId;
        }
        if (postMessageData.PromCode) {
            options.PromCode = postMessageData.PromCode;
        }

        if(channel) {
            options.channel = channel;
        }

        this._serviceFactory.cashierProxyService().openCashier(options);
    }

    /**
     * Handle post message with ActionId = 6 - CASHIER
     * Based on tab id on this post message, we can open either deposit, either cashout
     * @param postMessageData
     * @private
     */
    _handleCashierOpening(postMessageData) {
        let channelElement = null;
        let sessionType = postMessageData.TabId;


        if (isDepositSessionType(sessionType)) {
            channelElement = CHANNEL_ELEMENTS.depositButton;
        } else if (isCashoutSessionType(sessionType)) {
            channelElement = CHANNEL_ELEMENTS.withdrawButton;
        }

        this.openCashier(postMessageData, {
            source: CHANNEL_SOURCE.myAccount,
            area: AreaType.Header,
            element: channelElement
        });
    }

    /**
     * Handle post message with ActionId = 7 - QUICK_DEPOSIT
     * @param postMessageData
     * @private
     */
    _handleQuickDeposit(postMessageData) {
        let options = {};
        if (postMessageData.PromCode) {
            //update promo code to open cashier with one received from My Account
            options.PromCode = postMessageData.PromCode;
        }

        this._serviceFactory.cashierProxyService().openDeposit({
            ...options,
            channel: {
                source: CHANNEL_SOURCE.myAccount,
                area: AreaType.Header,
                element: CHANNEL_ELEMENTS.depositButton
            }
        });

        this.close();

    }


    /**
     * Open real game by gameType
     * @param gameType
     * @private
     */
    openRealGame(gameType, referrerID) {

        let gameOptions = {
            gameType: gameType * 1
        };

        if(!_.isNullOrUndefined(referrerID)) {
            gameOptions.referrerId = referrerID
        }

        return ServiceFactory.create().gameService().openRealGame(gameOptions);
    }

    /**
     * Open anonymous game by gameType
     * @param gameType
     * @private
     */
    openAnonymousGame(gameType) {
        return ServiceFactory.create().gameService().openAnonymousGame({
            gameType: gameType * 1
        });
    }


    /**
     * Handle post message with ActionId = 73 - Membership
     * @private
     */
    _handleOpenWebLogin(){
        ServiceFactory.create().webLoginService().openLoginForm();
    }

    /**
     * Handle post message with ActionId = 75 - UPLOAD_DOCUMENTS_IV
     */
    _handleUploadDocumentsIv(){
        ServiceFactory.create().openLinkService().openLink({source: GNWP_SOURCES.DOCUMENT_UPLOAD});
    }
}

export default ExternalLinksBaseHandler;